import { AxiosResponse } from 'axios';
import { HttpRequest } from '../../lib/http';
import { API } from './constant';

export const getNovaPostWarehouses = (query: string, cityId: string) => {
  if (!cityId) {
    return Promise.resolve({
      data: [],
      status: 200,
      statusText: 'OK',
      headers: {},
      config: {},
    } as AxiosResponse);
  }
  return HttpRequest({
    method: API.WAREHOUSE.TYPE,
    url: API.WAREHOUSE.URL,
    params: { query, cityId },
  });
};
